export enum EndPoint {

    // API_URL = 'https://portal.zerocarbon.com.pk',
    API_URL = 'https://admin.zerocarbon.com.pk/iot_api',
    // API_URL = 'http://726f6c2a153a.ngrok.io/iot_api',
    // API_URL = 'http://localhost:8000',
    dashboard = '/auth/GetExectiveDashboard',
}
export enum Auth {
    login = '/login',
}
export enum PlantEndPoints {
    AllPlants = '/plants',
    editPlants = '/plants/edit',
    PlantType = '/plants/plant_type',
    Plants = '/plants/add',
    PlantsImages = '/plants/add_images',
    TerrifList = '/get_tarrif_list',
    device = '/get_device_id_from_serial_id',
    EditTariffData = '/edit_tarrif_list',
    newTarrifCompany = '/add_company_name',
    newTarrifCompanyType = '/add_tarrif_type_name',
    updatenetmeteredstatusplant='/update_net_metered_status_plant'
}

export enum CustomerEndPoints {
    customers = '/customers',
    Users = '/customers/users',
    AddCustomer = '/customers/add',
    associatePlant = '/plants/associate_customer',
}

export enum InverterEndPoints {
    AddInverter = '/inverters/add',
    InverterCompany = '/get_inverter_companies',
    Inverters = '/inverters',
    InvertersEdit = '/inverters/edit',
    InverterCompanyDetail = '/inverters/get_company_info/',
    ManageInverter = '/inverters/save_inverter_info',
    Delete = '/inverters',
    mpptGet = '/inverters/get_mptt_values',
    mpptPost = '/inverters/insert_mptt_values',
}


export enum AlarmaEndpoint {
    get = '/get_all_alarms',
    post = '/update_alarm_status'
}